module.exports = __webpack_public_path__ + "static/img/sc01.22a9664e.png";